/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { Flex, If } from '@cleartax/zoids';
import './toolBar.css';
import { useHistory } from 'react-router-dom';
import {
  BizDetails,
  BizName,
  HamburgerImg,
  INVBizName,
  ToolBarDiv,
  ToolBarIconsDiv,
  RefreshLink
} from './styles';
import {
  HAMBURGER,
  VECTOR_BACK_ICON,
  // SHARE_ICON,
  // DOWNLOAD_ICON,
} from '../../../constants/urls';
import { UserContext } from '../../context/userContext';
import { useGlobalState } from '../../context/qrState';
import { EventIDs } from '../../../analytics/events';
import { track } from '../../../analytics/analytics';
import REFRESH_ICON from '../../../assets/refresh_icon.png';

interface Props {
  clicked: (arg0: string) => void;
}

const ToolBar: React.FC<Props> = ({ clicked }) => {
  const [page, setPage] = useState('DEFAULT');
  const history = useHistory();
  const {
    businessName,
    businessHierarchy,
    pageName,
    businessDetails,
    email,
  } = useContext<Record<string, any>>(UserContext);
  const [bizName, setBizName] = useState(
    businessName || localStorage.getItem('BUSINESSNAME')
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      if (businessHierarchy && businessHierarchy.data.length === 0) {
        businessDetails.addBusinessName('No businesses added');
      }
    }, 500);
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessHierarchy]);

  useEffect(() => {
    if (businessName) {
      setBizName(businessName || localStorage.getItem('BUSINESSNAME'));
    }
  }, [businessName]);

  useEffect(() => {
    setPage(pageName);
  }, [pageName]);

  const [currentlyShowingQrDetails, updateQrDetailState] = useGlobalState(
    'onQrDetailPage'
  );
  const [activeNavItem, setActiveNavItem] = useGlobalState('isActive');
  const [outOfScanner, updateExitScanner] = useGlobalState('exitScanner');
  const [complianceOrgID, setComplianceOrgID] = useGlobalState(
    'complianceCardOrgID'
  );
  const [complianceListHeader, setComplianceListHeader] = useGlobalState(
    'complianceINVListHeader'
  );
  const [pageNumber, setPageNumber] = useGlobalState('pageNumber');

  const headerValue = localStorage.getItem('HEADER_DATA');
  let showingGSTIN = true;
  if (headerValue) {
    JSON.parse(headerValue);
    if (JSON.parse(headerValue).branchName === JSON.parse(headerValue).gstin) {
      showingGSTIN = false;
    } else {
      showingGSTIN = true;
    }
  }

  const handleRefreshClick = ()=> {
    document?.location?.reload();
  }

  return (
    <ToolBarDiv 
    compliance={window.location.pathname === '/invcompliance'}
    style={page === 'FEEDBACK'? {
      boxShadow: "0px 2px 32px rgba(69, 74, 222, 0.12)" } : { } }>
      <If
        condition={
          page === 'DEFAULT' ||
          page === 'MIS' ||
          page === 'INVOICES' ||
          page === 'ALERTS'
        }
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <HamburgerImg
            onClick={() => {
              const payload = {
                email,
              };
              track(EventIDs.HAMBURGERGER, payload);
              clicked('DEFAULT');
              setActiveNavItem('');
            }}
            src={HAMBURGER}
            alt=""
            width="16"
            height="16"
          />
          <If
            condition={
              page === 'DEFAULT' || page === 'MIS' || page === 'INVOICES'
            }
          >
            <BizName style={{
              width: '70%',
            }}>
              <span
                style={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  width: '90%',
                }}
              >
                {bizName}
              </span>
            </BizName>
            <RefreshLink onClick={handleRefreshClick}>
              <img
                style={{ width: '20px', height: '20px', marginRight: '2px' }}
                src={REFRESH_ICON}
                alt=''
              />
              <span>Refresh</span>
            </RefreshLink>
          </If>
          <If condition={page === 'ALERTS'}>
            <BizName>Alerts</BizName>
          </If>
        </div>
        {/* <ToolBarIconsDiv>
          <If condition={page === 'MIS'|| page === 'INVOICES'}>
            <img src={DOWNLOAD_ICON} alt="" width="48px" height="48px" />
            <img src={SHARE_ICON} alt="" width="24px" height="24px"/>
          </If>
        </ToolBarIconsDiv> */}
      </If>
      <If condition={page === 'QR' || page === 'COMING SOON'|| page === 'FEEDBACK'}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '80%',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <If condition={currentlyShowingQrDetails}>
            <HamburgerImg
              src={VECTOR_BACK_ICON}
              alt=""
              width="48"
              height="48"
              style={{ marginLeft: '-6%' }}
              onClick={() => {
                setActiveNavItem('');
                if (currentlyShowingQrDetails) {
                  updateQrDetailState(false);
                } else {
                  updateExitScanner(true);
                  history.goBack();
                }
              }}
            />
          </If>
          <If condition={page === 'QR'||page === 'FEEDBACK'}>
            <BizName style={{ marginLeft:"-3%" }}>
              { page === 'FEEDBACK'? 'Give us Feedback' : currentlyShowingQrDetails ? 'QR Code Details' : 'Scan QR Code' }
            </BizName>
          </If>
        </div>
      </If>
      <If condition={page === 'INVOICES_COMPLIANCE'}>
        <Flex
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          width="90%"
        >
          <HamburgerImg
            onClick={() => {
              setComplianceOrgID('');
              localStorage.setItem('COMPLIANCE_ID', '');
              setPageNumber(0);
              history.goBack();
            }}
            src={VECTOR_BACK_ICON}
            alt=""
            width="50"
            height="50"
          />
          <Flex
            flexDirection="column"
            alignItems="flex-start"
            justifyContent="space-between"
            width="100%"
          >
            <INVBizName>
              {headerValue
                ? JSON.parse(headerValue).branchName
                : complianceListHeader.branchName}
            </INVBizName>
            <BizDetails>
              <If condition={showingGSTIN === true}>
                <span>
                  {headerValue
                    ? JSON.parse(headerValue).gstinOrgName
                    : complianceListHeader.gstinOrgName}{' '}
                  | GSTIN:
                  {headerValue
                    ? JSON.parse(headerValue).gstin
                    : complianceListHeader.gstin}
                </span>
              </If>
              <If condition={showingGSTIN === false}>
                <span>
                  {headerValue
                    ? JSON.parse(headerValue).gstinOrgName
                    : complianceListHeader.gstinOrgName}
                </span>
              </If>
            </BizDetails>
          </Flex>
        </Flex>
      </If>
    </ToolBarDiv>
  );
};
export default ToolBar;
